import React, { useEffect, useState } from 'react';
var PolicyDocumentTimer = function (_a) {
    var nextPolicyDocumentFetchAtMs = _a.nextPolicyDocumentFetchAtMs, onFinished = _a.onFinished;
    var _b = useState(''), remainingTime = _b[0], setRemainingTime = _b[1];
    useEffect(function () {
        if (!nextPolicyDocumentFetchAtMs) {
            setRemainingTime('');
            return;
        }
        var interval = setInterval(function () {
            var diff = nextPolicyDocumentFetchAtMs - Date.now();
            if (diff <= 0) {
                setRemainingTime('');
                clearInterval(interval);
                onFinished();
                return;
            }
            var minutes = Math.floor(diff / 60000);
            var seconds = Math.floor((diff % 60000) / 1000);
            setRemainingTime("".concat(minutes, ":").concat(seconds.toString().padStart(2, '0')));
        }, 1000);
        return function () { return clearInterval(interval); };
    }, [nextPolicyDocumentFetchAtMs, onFinished]);
    return React.createElement("span", null, "You can fetch after : ".concat(remainingTime));
};
export default PolicyDocumentTimer;
